module.exports = __webpack_public_path__ + "img/back.0d5114fd.png";